export const PERSON_SEARCH_MAX_RESULTS_LENGTH = 200;
